import BaseIvrNode from './baseIvrNode';
import { getMessageTypeClass, MessageRecording, MessageText } from './message';
import { IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export default class MessageNode extends BaseIvrNode {
  @ValidateNested()
  @Type(getMessageTypeClass)
  message: MessageText | MessageRecording;

  @IsString()
  @IsOptional()
  nextId?: string;
}
